import React from 'react';
import { Slider, Typography } from '@material-ui/core';
import { useFormContext } from '../FormContext';
import ConfigCard from './components/ConfigCard';
import ConfigContent from './components/ConfigContent';
import ConfigFieldControl from './components/ConfigFieldControl';
import { ConfigHeader } from './components/ConfigHeader';
export const FormConfigLayout = () => {
    var _a;
    const { formState, updateElement, elementPlugins } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    const plugin = elementPlugins.find(p => p.type === element.type);
    return (React.createElement(ConfigCard, null,
        React.createElement(ConfigHeader, null, "Layout"),
        React.createElement(ConfigContent, null,
            (plugin === null || plugin === void 0 ? void 0 : plugin.layoutConfigurator) && React.createElement(plugin.layoutConfigurator, null),
            React.createElement(ConfigFieldControl, null,
                React.createElement(Typography, { variant: 'caption' }, "Field Size"),
                React.createElement(Slider, { marks: true, defaultValue: 12, step: 2, min: 4, max: 12, value: ((_a = element.breakpoints) === null || _a === void 0 ? void 0 : _a.md) || 12, onChange: (event, value) => {
                        const breakpoints = { md: value };
                        updateElement({ breakpoints });
                    } }),
                React.createElement(Typography, { variant: 'caption' }, "(The field size only applies to non-mobile screen sizes.)")))));
};
export default FormConfigLayout;
//# sourceMappingURL=FormConfigLayout.js.map